var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguageLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35327 5.5C2.35327 2.73858 4.59185 0.5 7.35327 0.5C10.1147 0.5 12.3533 2.73858 12.3533 5.5C12.3533 8.26142 10.1147 10.5 7.35327 10.5C4.59185 10.5 2.35327 8.26142 2.35327 5.5ZM7.35327 8.5C5.69642 8.5 4.35327 7.15685 4.35327 5.5C4.35327 3.84315 5.69642 2.5 7.35327 2.5C9.01013 2.5 10.3533 3.84315 10.3533 5.5C10.3533 7.15685 9.01013 8.5 7.35327 8.5Z",
    fill: "#3479EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9.62943C1.75216 11.7031 3.9189 13.1624 6.44141 13.4486V15.5H4.35327V17.5H10.3533V15.5H8.44141V13.4266C12.3449 12.8958 15.3532 9.54919 15.3532 5.50001C15.3532 3.93638 14.9046 2.47752 14.1291 1.24512L12.4253 2.29326C13.013 3.22084 13.3532 4.32069 13.3532 5.50001C13.3532 8.81371 10.667 11.5 7.35324 11.5C5.16611 11.5 3.25231 10.3298 2.20381 8.58128L0.5 9.62943Z",
    fill: "#3479EE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageLogo);
export default __webpack_public_path__ + "static/media/language-logo.f5a25a605bcdac495003177123a8e6d5.svg";
export { ForwardRef as ReactComponent };